import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconArrow = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-arrow' + (className ? ` ${className}` : '')}
            fill='none'
            viewBox='0 0 6 10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.73821 4.51604L0.177168 0.955209C0.0618903 0.839792 0.00286247 0.712084 8.46941e-05 0.572084C-0.0025542 0.432223 0.0564736 0.301875 0.177168 0.181042C0.298001 0.0603473 0.427029 0 0.564251 0C0.701473 0 0.832793 0.0627089 0.95821 0.188126L4.82154 4.05125C4.88557 4.12097 4.93363 4.19424 4.96571 4.27104C4.99779 4.34785 5.01383 4.4309 5.01383 4.52021C5.01383 4.60951 4.99779 4.69257 4.96571 4.76938C4.93363 4.84618 4.88557 4.91667 4.82154 4.98083L0.95821 8.84396C0.83821 8.96396 0.711682 9.02188 0.578626 9.01771C0.445709 9.0134 0.318835 8.9509 0.198001 8.83021C0.0773069 8.70938 0.0169596 8.58035 0.0169596 8.44313C0.0169596 8.3059 0.0773069 8.17688 0.198001 8.05604L3.73821 4.51604Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconArrow;
